import { NetworkCode } from "@common/utils/http/types";
import axios from "axios";

const request = axios.create({
  baseURL: import.meta.env.VITE_OS_BACKEND_URL,
});

export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

request.interceptors.response.use(
  async (response) => {
    if (response.data && response.data.code === NetworkCode.success) {
      return response.data.data;
    }
    if (response.status === 200 && response.data.code === NetworkCode.doing) {
      // 这种情况稍微delay一下，再重试一次
      // 避免频繁请求重试
      await delay(10 * 1000);
      return request(response.config);
    }
    return Promise.reject(response.data);
  },
  (error) => {
    console.log("[request error]", error);
    return Promise.reject(error);
  }
);

export default request;
